import React, {useEffect, useState} from "react";
import {Button, Card, Col, Row, Spinner} from "reactstrap";
import useApiCallService from "../../Common/Helpers/ApiCall";
import {ChangeDateFormat} from "../../Common/Helpers/ChangeDateFormat";
import {useNavigate} from "react-router-dom";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import {ADMIN_PATHS} from "../../config";
import ResponseUserModel from "../../User/Models/Response/ResponseUserModel";
import AdminResponseHonorarium from "../Models/Response/AdminResponseHonorarium";
import {FlashMessage} from "../../Common/Helpers/FlashMessage";
import ResponseOrgModel from "../../Org/Models/Response/ResponseOrgModel";
import {useTranslation} from "react-i18next";
import AdminRequestHonorariumUpdate from "../Models/Request/AdminRequestHonorariumUpdate";
import {CheckDecimal} from "../../Common/Helpers/CheckDecimal";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import {CheckUserPermission} from "../../AppSystem/Helpers/CheckUserPermission";
import CostBearerModel from "../../CostBearer/Models/Response/CostBearerModel";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import { InfoPageMessage } from "../../Common/Components/Button/InfoPageMessage";
import { CustomModal } from "../../Common/Components/Modal/CustomModal";
import $ from 'jquery'
import { CustomReload } from "../../AppSystem/Helpers/CustomReload";

const AdminHonorariumUpdate = () => {
    const { t } = useTranslation();
    const { ApiCall } = useApiCallService();
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id') ?? "";
    const navigate = useNavigate();

    const [honorarium, setHonorarium] = useState(new AdminResponseHonorarium());

    const [editHonorarium, setEditHonorarium] = useState(new AdminRequestHonorariumUpdate());
    const [editMode, setEditMode] = useState(true);
    const [displaySpinner, setDisplaySpinner] = useState(false);

    const [apiResponseUser, setApiResponseUser] = useState(null);
    const [apiResponseOrg, setApiResponseOrg] = useState(null);
    const [costResponse, setCostResponse] = useState(null);
    const [responseDelete, setResponseDelete] = useState(null);

    const [costJson, setCostJson] = useState({});
    const [jsonUsers, setJsonUsers] = useState({});
    const [jsonOrg, setJsonOrg] = useState({});

    const [isSend, setIsSend] = useState(false);
    
    //MODALS
    const [displaySendModal, setDisplaySendModal] = useState(false);
    const [displaySendDraftModal, setDisplaySendDraftModal] = useState(false);
    const [displayDeleteHonorariumModal, setDisplayDeleteHonorariumModal] = useState(false);

    const completeSchemaHonorarium = AdminRequestHonorariumUpdate.getAttributes( null, true);

    let permission = false;
    if (CheckUserPermission("admin") || CheckUserPermission("admin.honorarium") || CheckUserPermission("admin.honorarium.update")) {
        permission = true;
    }


    // GET HONORARIUM
    useEffect(() => {
        if (id !== "") {
            const handleApiResponse = (apiResponse) => {
                setHonorarium(new AdminResponseHonorarium(apiResponse));
                setEditHonorarium(new AdminRequestHonorariumUpdate(apiResponse))
            };
            const fetchData = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/honorarium/admin?id=${id}`
                    };
                    await ApiCall(apiCallOptions, handleApiResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            fetchData();
        }
    }, []);

    // GET USERS FOR SELECT
    useEffect(() => {
        const userData = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: '/user/admin/search?perPage=10000'
                };
                await ApiCall(apiCallOptions, setApiResponseUser);
            } catch (error) {
                console.log('error', error);
            }
        };
        userData()
    }, []);

    useEffect(() => {
        if (apiResponseUser !== null) {
            const userArray = [];
            apiResponseUser.items.forEach((item) => {
                const userModel = new ResponseUserModel(item);
                userArray.push(userModel);
            });
            setJsonUsers({
                userId: userArray,
            });
        }
    }, [apiResponseUser]);

    //GET ORGANIZATIONS FOR SELECT
    useEffect(() => {
        if (honorarium.userId !== "" || editHonorarium.userId !== "") {
            const handleApiResponse = (apiResponse) => {
                setApiResponseOrg(apiResponse);
            };
            const orgData = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/user/admin/org-user/search?userid=${editMode === true ? editHonorarium.userId : honorarium.userId}&perPage=10000`,
                    };
                    await ApiCall(apiCallOptions, handleApiResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            orgData();
        }
    }, [/*honorarium.userId,*/ editHonorarium.userId]);

    useEffect(() => {
        if (apiResponseOrg !== null) {
            const orgArray = [];
            apiResponseOrg.items.forEach((item) => {
                const orgModel = new ResponseOrgModel(item);
                orgArray.push(orgModel);
            });
            setJsonOrg({
                orgId: orgArray,
            });
        }
    }, [apiResponseOrg]);

    // API CALL TO GET COST BEARER
    useEffect(() => {
        if (editHonorarium.orgId !== "") {
            const handleCostResponse = (costResponse) => {
                setCostResponse(costResponse);
            };
            const CostApiCall = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/costbearer/list-org?id=" + editHonorarium.orgId,
                    };
                    await ApiCall(apiCallOptions, handleCostResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            CostApiCall();
        }
    }, [editHonorarium.orgId]);

    useEffect(() => {
        if (costResponse !== null) {
            const costBearerArray = [];
            costResponse.forEach((item) => {
                const cosBearerModel = new CostBearerModel(item);
                costBearerArray.push(cosBearerModel);
            });
            setCostJson({
                costBearer: costBearerArray
            });
        }
    }, [costResponse]);

    const handleChangeHonorarium = (e, name) => {
        let value;
        if (e && e.target && e.target.value) {
            value = e.target.value;
        }
        if (name === 'paymentInterval') {
            if (e && e.target && e.target.value) {
                value = parseInt(e.target.value);
            } else {
                value = 0;
            }
        }
        if (name === 'annualHonorarium') {
            if (e.target.value !== "") {
                value = CheckDecimal(e.target.value);
            } else {
                value = 0;
            }
        }
        if (name === 'firstPayment') {
            value = ChangeDateFormat('date', e);
        }
        if (name === "userId") {
            if (apiResponseUser !== null) {
                apiResponseUser.items.map(item => {
                    if (e.value !== undefined) {
                        if (item.id === e.value) {
                            value = e.value;
                        }
                    }
                });
                setEditHonorarium((prevFormData) => ({
                    ...prevFormData,
                    orgId: '',
                }));
            }
        }
        if (name === "orgId") {
            if (apiResponseOrg !== null) {
                apiResponseOrg.items.map(item => {
                    if (e.value !== undefined) {
                        if (item.id === e.value) {
                            value = e.value;
                        }
                    }
                });
            }
        }

        if (name === "costBearerId" && costResponse !== null) {
            costResponse.forEach(item => {
                if (item.id === e.target.value) {
                    value = e.target.value;
                }
            });
        }
        setEditHonorarium((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    }

    const handleValidation = async (status) => {
        try {
            await completeSchemaHonorarium.validate(editHonorarium, { abortEarly: false });

            if (status) {
                editHonorarium.status = status;
            }

            const apiCallOptions = {
                method: "put",
                url: "/honorarium/admin",
                data: editHonorarium,
            };
            try {
                await ApiCall(apiCallOptions, setHonorarium);
                setEditMode(false);
                FlashMessage(t('validationMessage.honorariumUpdate'), 'flash-messageSuccess');
                setTimeout(()=>{
                    navigate(`${ADMIN_PATHS.HONORARIUM_INFO}?id=${honorarium.id}`);
                },2000);
            } catch (error) {
                console.log(error);
                FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
            }
        } catch (err) {
            console.log(err)
        }
    }

    // TODO: MOVE TO CUSTOM INPUT
    const annualHonorariumInput = document.getElementById('annualHonorarium');
    if (annualHonorariumInput) {
        annualHonorariumInput.addEventListener('keypress', function(e) {
            const key = e.key;
            if (!((key >= '0' && key <= '9') || key === '.' || key === ',')) {
                e.preventDefault();
            }
        });
    }

    //const paymentsDone = honorarium.queuedPayments.length > 0 ? honorarium.queuedPayments.some(item => item.done === true) : false;
    //const paid = t('modelLabel.paid');
    //const unpaid = t('modelLabel.unpaid');
    //const yearly = t('modelLabel.yearly');
    const monthly = t('modelLabel.monthly');

    // HANDLE MODAL DELETE
    const HandleDeleteHonorarium = async () => {
        if (id !== "") {
            const apiCallOptions = {
                method: "delete",
                url: `/honorarium`,
                data: {id: id}
            };
            try {
                await ApiCall(apiCallOptions, setResponseDelete);
                setDisplayDeleteHonorariumModal(false);
            } catch (error) {
                //console.log({error});
            }
        }
    }


     useEffect(() => {
            if (responseDelete !== null) {
                CustomReload(ADMIN_PATHS.HONORARIUM_LIST);
            }
        }, [responseDelete]);

    // CHECK REQUIRED INPUTS
    const CheckRequired = () => {
        $("#userId").focus();
        $("#orgId").focus();
        $("#firstPayment").focus();
        $("#paymentInterval").focus();
        $("#costBearerId").focus();
        $("#annualHonorarium").focus();
        setTimeout(() => {
            $('.react-datepicker__tab-loop').addClass('d-none');
            $("#userId").blur();
            $("#orgId").blur();
            $("#firstPayment").blur();
            $("#paymentInterval").blur();
            $("#costBearerId").blur();
            $("#annualHonorarium").blur();
        },1)
        if (honorarium.date === "" || honorarium.orgId === "" || honorarium.purpose === "" || honorarium.costBearerId === "" || honorarium.annualHonorarium === 0 || honorarium.firstPayment === "" || honorarium.paymentInterval === "") {
            return false;
        }
        return true;
    }

    const modalSendContent = (
        <div id="sendMessageDiv">
            {isSend === false ? t('honorarium.honorariumModalSend') : t('honorarium.honorariumModalSend')}
        </div>
    );
    const modalSendFooter = (
        <>
            <Button className="box-green border-0" id="sendButton" onClick={async () => {
                setDisplaySendModal(false);
                await handleValidation("Skickat");
            }}>
                {t('button.send')}
            </Button>
            <Button className="box-red border-0" onClick={() => {
                setDisplaySendModal(false)
                $("#forms").removeClass("d-none");
            }}>{t('button.cancel')}</Button>
        </>
    );

    const modalSendDraftContent = (
        <div id="sendMessageDiv">
            {isSend === false ? t('honorarium.honorariumModalDraft') : t('honorarium.honorariumModalDraft')}
        </div>
    );
    const modalSendDraftFooter = (
        <>
            <Button className="box-green border-0" id="sendButton" onClick={async () => {
                setDisplaySendDraftModal(false);
                await handleValidation();
            }}>
                {t('button.save')}
            </Button>
            <Button className="box-red border-0" onClick={() => {
                setDisplaySendDraftModal(false)
                $("#forms").removeClass("d-none");
            }}>{t('button.cancel')}</Button>
        </>
    );

    const modalContentDeleteHonorariumModal = (
            <div>
                {`${t('validationMessage.modalVar')}?`}
            </div>
        );
        const modalFooterDeleteHonorariumModal = (
            <>
                <Button className="box-green border-0" onClick={HandleDeleteHonorarium}>
                    {t('button.delete')}
                </Button>
                <Button className="box-red border-0" onClick={() => setDisplayDeleteHonorariumModal(false)}>{t('button.cancel')}</Button>
            </>
        );

    return (
        <>
            <CustomModal isOpen={displaySendDraftModal} toggle={() => setDisplaySendDraftModal(!displaySendDraftModal)} body={modalSendDraftContent} footer={modalSendDraftFooter} />
            <CustomModal isOpen={displaySendModal} toggle={() => setDisplaySendModal(!displaySendModal)} body={modalSendContent} footer={modalSendFooter} />
            <CustomModal isOpen={displayDeleteHonorariumModal} toggle={() => setDisplayDeleteHonorariumModal(!displayDeleteHonorariumModal)} body={modalContentDeleteHonorariumModal} footer={modalFooterDeleteHonorariumModal} />
            <Col lg={12} >
                <CustomButton
                    text={t('button.back')}
                    icon={'bx bx-chevron-left'}
                    buttonSize={'small'}
                    customClasses={'ms-3 mb-3'}
                    onClick={() => {
                        navigate(ADMIN_PATHS.HONORARIUM_LIST)
                    }}
                />
            </Col>
            <>
            <Row className="pb-4">
                <Col lg={6}>
                    <Card className="card-backend p-4">
                        <Row>
                            <Col lg={12}>
                                <h2 className="rokkitt-font">{t('honorarium.update')}</h2>
                            </Col>
                            <InfoPageMessage message={'Test: message create Honorarium'}/>
                            <Col lg={12}>
                                    <Row>
                                        <Col lg={6}>
                                            <div className={'mb-3'}>
                                                <CustomInput model={AdminRequestHonorariumUpdate} attribute='userId' data={editHonorarium.userId} customChange={(e) => {
                                                    handleChangeHonorarium(e, 'userId');
                                                    setEditHonorarium((prevFormData) => ({
                                                        ...prevFormData,
                                                        orgId: "",
                                                    }));
                                                }} customOptions={jsonUsers}/>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            {apiResponseOrg === null ? <span className="text-danger">¡¡ This User does not have any Organization !!</span> : ''}
                                            <CustomInput model={AdminRequestHonorariumUpdate} attribute='orgId' data={/*honorarium.orgId*/ editHonorarium.orgId} customChange={(e) => {
                                                handleChangeHonorarium(e, 'orgId');
                                                setEditHonorarium((prevFormData) => ({
                                                    ...prevFormData,
                                                    costBearerId: "",
                                                }));
                                            }} customOptions={jsonOrg}/>
                                        </Col>
                                        <Col lg={6}>
                                            <CustomInput model={AdminRequestHonorariumUpdate} attribute='firstPayment' data={editHonorarium.firstPayment} customChange={(e) => handleChangeHonorarium(e, 'firstPayment')}/>
                                        </Col>
                                        <Col lg={6}>
                                            <CustomInput model={AdminRequestHonorariumUpdate} attribute='paymentInterval' data={editHonorarium.paymentInterval} customChange={(e) => handleChangeHonorarium(e, 'paymentInterval')}/>
                                        </Col>
                                        <Col lg={6}>
                                            <CustomInput model={AdminRequestHonorariumUpdate} attribute='annualHonorarium' data={editHonorarium.annualHonorarium} customChange={(e) => handleChangeHonorarium(e, 'annualHonorarium')}
                                            />
                                        </Col>
                                        {editHonorarium.orgId !== "" ?
                                            <Col lg={6}>
                                                <CustomInput model={AdminRequestHonorariumUpdate} attribute='costBearerId' data={editHonorarium.costBearerId} customChange={(e) => handleChangeHonorarium(e, 'costBearerId')} customOptions={costJson}
                                                />
                                            </Col>
                                        : ''}
                                        <Col lg={12} className="text-end pt-5">
                                    {id !== "" ?
                                    <Button className=" rounded-2 box-red border-0  me-2 " onClick={() => {
                                        setDisplayDeleteHonorariumModal(true);
                                    }}>
                                        <i className="bx bx-x-circle fs-5 pe-1"/> {t("button.delete")}
                                    </Button>
                                : ''}
                                <CustomSubmitButton customClass="me-2" text={t('button.saveReimbursement')} id='saveReimbursement' icon='bx bx-save pe-2' doClick={false}
                                    customClick={async () => {
                                        if (CheckRequired()) {
                                            $("#forms").addClass("d-none");
                                            setIsSend(false);
                                        //     checkIfHaveChanges("save");
                                            setDisplaySendDraftModal(true);
                                        }
                                    }}
                                />
                                    {displaySpinner === true ?
                                        <>
                                            {t('validationMessage.sendingHonorarium')} <Spinner color='success' className="me-3" />
                                        </>
                                    : ''}
                                    <CustomSubmitButton text={t('button.send')} id='submitHonorarium' icon='bx bx-send pe-2' customClick={async () => {
                                        if (CheckRequired()) {
                                            $("#forms").addClass("d-none");
                                            setIsSend(false);
                                        //     checkIfHaveChanges("save");
                                            setDisplaySendModal(true);
                                        }
                                    }} />
                                </Col>
                                    </Row>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
            </>
        </>
    );
};

export default AdminHonorariumUpdate;